<template>
  <content-item>
    <div class="right">
      <app-settings-col class="field_left">
        <app-input
            required
            :error="errorsProp.items.find(el => el.field === 'name')"
            :label="translations.name"
            name="name"
            v-model="watchedItem.name"
            :disabled="pending || disabled"
            :copy-icon="true"
            @input="$emit('nameChange', $event)"
            @copyName="copyName"
        />
        <app-input
            :error="errorsProp.items.find(el => el.field === 'originalName')"
            :label="translations.originalName"
            name="originalName"
            v-model="watchedItem.originalName"
            :disabled="pending || disabled"
        />
        <app-input
            required
            :error="errorsProp.items.find(el => el.field === 'rating')"
            :label="translations.rating"
            type="number"
            :step="0.01"
            name="rating"
            v-model="watchedItem.rating"
            :disabled="pending || disabled"
        />
        <app-input
            :error="errorsProp.items.find(el => el.field === 'yearStart')"
            :label="translations.yearStart"
            type="number"
            name="yearStart"
            v-model="watchedItem.yearStart"
            :disabled="pending || disabled"
        />
        <app-input
            :error="errorsProp.items.find(el => el.field === 'yearEnd')"
            :label="translations.yearEnd"
            type="number"
            name="yearEnd"
            v-model="watchedItem.yearEnd"
            :disabled="pending || disabled"
        />
        <app-input
            :error="errorsProp.items.find(el => el.field === 'duration')"
            :label="translations.duration"
            type="number"
            name="duration"
            v-model="watchedItem.duration"
            :disabled="pending || disabled"
        />
        <app-input
            :error="errorsProp.items.find(el => el.field === 'directors')"
            :label="translations.directors"
            name="directors"
            v-model="watchedItem.directors"
            :disabled="pending || disabled"
        />
        <app-settings-input
            :error="errorsProp.items.find(el => el.field === 'cast')"
            :label="translations.cast"
        >
          <app-textarea
              rows="11"
              name="cast"
              v-model="watchedItem.cast"
              :disabled="pending || disabled"
          />
        </app-settings-input>
        <app-input
            :error="errorsProp.items.find(el => el.field === 'originalGenre')"
            :label="translations.originalGenre"
            name="originalGenre"
            v-model="watchedItem.originalRedGenre"
            :disabled="true"
        />
      </app-settings-col>

      <app-settings-col class="field_right">
        <app-image
          pClass="field field_poster"
          :labelTitle="translations.poster"
          labelClass="poster add_profile_image"
          spanClass="sizes"
          :image="primaryPortrait"
        />
        <app-image
          pClass="field field_poster"
          :labelTitle="translations.photo"
          labelClass="photo add_profile_image"
          spanClass="sizes"
          :image="primaryLandscape"
        />
        <app-settings-input
            :error="errorsProp.items.find(el => el.field === 'note')"
            :label="translations.note"
        >
          <app-textarea
              :local-id="'note'"
              rows="5"
              name="note"
              v-model="watchedItem.note"
              :disabled="pending || disabled"
          />
        </app-settings-input>
        <app-input
            :error="errorsProp.items.find(el => el.field === 'csfdId')"
            :label="translations.csfdId"
            type="number"
            name="csfdId"
            v-model="watchedItem.csfdId"
            :disabled="pending || disabled"
        />
        <app-input
            :error="errorsProp.items.find(el => el.field === 'imdbId')"
            :label="translations.imdbId"
            name="imdbId"
            v-model="watchedItem.imdbId"
            :disabled="pending || disabled"
        />
        <app-input
            :error="errorsProp.items.find(el => el.field === 'tmdbId')"
            :label="translations.tmdbId"
            type="number"
            name="tmdbId"
            v-model="watchedItem.tmdbId"
            :disabled="pending || disabled"
        />
        <app-input
            :error="errorsProp.items.find(el => el.field === 'youtubeLink')"
            :label="translations.trailer"
            name="youtubeLink"
            v-model="watchedItem.youtubeLink"
            :disabled="pending || disabled"
        />
        <app-input
            :error="errorsProp.items.find(el => el.field === 'dataSource')"
            :label="translations.dataSource"
            name="dataSource"
            v-model="watchedItem.dataSource"
            :disabled="true"
        />
        <app-settings-input
            :error="errorsProp.items.find(el => el.field === 'leadParagraph')"
            :label="translations.leadParagraph"
        >
          <app-textarea
              name="leadParagraph"
              rows="6"
              v-model="watchedItem.leadParagraph"
              :disabled="pending || disabled"
          />
        </app-settings-input>
      </app-settings-col>

      <app-settings-input
            :error="errorsProp.items.find(el => el.field === 'description')"
            :label="translations.longDescription"
        >
        <app-textarea
            name="description"
            rows="6"
            v-model="watchedItem.description"
            :disabled="pending || disabled"
        />
      </app-settings-input>

      <app-settings-select
          required
          :error="errors.items.find(el => el.field === 'isPeriodic')"
          :label="translations.periodical"
          class="field_left"
      >
        <app-select
            selectId="isPeriodic"
            name="isPeriodic"
            :options="periodicOptions"
            v-model="watchedItem.isPeriodic"
            :disabled="pending || disabled"
        />
      </app-settings-select>

      <app-settings-col class="field_right">
        <app-checkbox
            :error="!!errorsProp.first('broadcastsAssignable')"
            class="checkbox-block"
            name="broadcastsAssignable"
            :title="translations.assignable"
            v-model="watchedItem.broadcastsAssignable"
            :disabled="pending || disabled"
        />
        <app-input
            v-if="watchedItem.automaticallyCreated"
            :label="translations.createdFromEpgSource"
            name="createdFromEpgSource"
            v-model="watchedItem.createdFromEpgSource"
            disabled
        />
      </app-settings-col>
      <app-settings-col class="field_left">
        <app-checkbox
            class="checkbox-block"
            name="automaticallyGenerated"
            :title="translations.automaticallyCreated"
            v-model="watchedItem.automaticallyCreated"
            disabled
        />
      </app-settings-col>
      <app-settings-col class="field_left" v-if="watchedItem.automaticallyCreated">
        <app-checkbox
            class="checkbox-block"
            name="manuallyUpdated"
            :title="translations.manuallyUpdated"
            v-model="watchedItem.manuallyUpdated"
            disabled
        />
      </app-settings-col>
      <app-settings-col class="field_right" v-if="watchedItem.automaticallyCreated && watchedItem.manuallyUpdated && watchedItem.timestampFirstManuallyUpdate">
        <label>{{ translations.timestampFirstManuallyUpdate }}:&nbsp;</label>
        <label
            :label="translations.timestampFirstManuallyUpdate"
            name="timestampFirstManuallyUpdate"
            v-html="formatDate(watchedItem.timestampFirstManuallyUpdate)"
            disabled
        />
      </app-settings-col>
    </div>
  </content-item>
</template>

<script>
import ContentItem from './ContentItem'
import { mapState, mapActions } from 'vuex'
import { SHOW_TEMPLATE } from '../../../constants/showTemplate'
import formatDateMixin from '@/mixins/formatDateMixin'

export default {
  name: 'information-details',
  mixins: [ formatDateMixin ],
  components: {
    ContentItem
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    pending: {
      type: Boolean,
      default: false
    },
    errorsProp: {
      type: Object,
      required: true
    },
    isNewItem: {
      type: Boolean,
      default: false
    },
    parentName: {
      type: String,
      default: ''
    },
    parentId: {
      type: Number | String,
      default: null
    },
    isEpg: {
      type: Boolean,
      default: false
    },
    selectedShowLanguageId: {
      type: Number,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.setWatchedItemIfNotPending()
    this.getPrimaryImagesIfNotNewItem()
  },
  beforeDestroy() {
    this.resetWatchedItem()
  },
  data() {
    return {
      watchedItem: {
        ...SHOW_TEMPLATE,
        languageId: null
      },
      newLangMutationId: null
    }
  },
  computed: {
    translations() {
      return {
        name: this.$gettext('Název'),
        originalName: this.$gettext('Originální název'),
        rating: this.$gettext('Hodnocení'),
        yearStart: this.$gettext('Rok výroby'),
        yearEnd: this.$gettext('Rok ukončení'),
        duration: this.$gettext('Stopáž (min)'),
        directors: this.$gettext('Režie'),
        cast: this.$gettext('Hrají/Účinkují'),
        note: this.$gettext('Poznámka'),
        poster: this.$gettext('Poster'),
        photo: this.$gettext('Fotka'),
        csfdId: this.$gettext('ČSFD ID (číslo)'),
        imdbId: this.$gettext('IMDb ID'),
        tmdbId: this.$gettext('TMDb ID (číslo)'),
        trailer: this.$gettext('Trailer'),
        dataSource: this.$gettext('Zdroj dat'),
        leadParagraph: this.$gettext('Perex'),
        longDescription: this.$gettext('Dlouhý popis'),
        assignable: this.$gettext('Navazovat'),
        createdFromEpgSource: this.$gettext('Vytvořen z EPG zdroje'),
        automaticallyCreated: this.$gettext('Vytvořen automaticky'),
        manuallyUpdated: this.$gettext('Manuálně upraveno'),
        timestampFirstManuallyUpdate: this.$gettext('Čas první manuální úpravy'),
        periodical: this.$gettext('Periodicita'),
        periodic: this.$gettext('Periodický'),
        periodicNull: this.$gettext('Neuvedeno'),
        periodicFalse: this.$gettext('Neperiodický'),
        originalGenre: this.$gettext('Originální žánr')
      }
    },
    periodicOptions() {
      return [
        { name: this.translations.periodicNull, value: null },
        { name: this.translations.periodic, value: true },
        { name: this.translations.periodicFalse, value: false }
      ]
    },
    primaryPortrait() {
      if (this.isNewItem) {
        return null
      }

      return this.$store.state.images.primaryImages.primaryPortrait
    },
    primaryLandscape() {
      if (this.isNewItem) {
        return null
      }

      return this.$store.state.images.primaryImages.primaryLandscape
    },
    parentNameAndId() {
      return `${this.parentName}|${this.parentId}`
    }
  },
  methods: {
    ...mapActions([
      'getPrimaryImages'
    ]),
    copyName(value) {
      this.watchedItem.originalName = value
    },
    setWatchedItemOnDataLoaded() {
      if (!(Object.keys(this.item).length === 0 && this.item.constructor === Object)) {
        Object.keys(this.watchedItem).forEach(v => (this.watchedItem[v] = this.item[v]))
      }
    },
    setWatchedItemIfNotPending() {
      if (!(Object.keys(this.item).length === 0 && this.item.constructor === Object) && !this.pending) {
        Object.keys(this.watchedItem).forEach(v => (this.watchedItem[v] = this.item[v]))
      }
    },
    resetWatchedItem() {
      Object.keys(SHOW_TEMPLATE).forEach(v => (this.watchedItem[v] = SHOW_TEMPLATE[v]))
    },
    getShowData() {
      return this.watchedItem
    },
    copyFromSourceData(sourceData) {
      Object.keys(this.watchedItem)
        .forEach(
          v => {
            if (sourceData[v] !== null) {
              this.watchedItem[v] = sourceData[v]
            }
          }
        )
    },
    copyFromExternalData(externalData) {
      Object.keys(externalData)
        .forEach(
          fieldName => {
            this.watchedItem[fieldName] = externalData[fieldName]
          }
        )
    },
    getPrimaryImagesIfNotNewItem() {
      if (this.isEpg) {
        if (this.parentName && this.parentId) {
          this.getPrimaryImages({
            params: {
              parentName: this.parentName,
              parentId: this.parentId
            }
          })
        }
      } else {
        if (!this.isNewItem) {
          this.getPrimaryImages({
            params: {
              parentName: this.parentName,
              parentId: this.parentId
            }
          })
        }
      }
    },
    createNewLanguageMutation() {
      const obj = this.watchedItem

      obj.name = null
      obj.leadParagraph = null
      obj.description = null
    }
  },
  watch: {
    item: {
      handler() {
        this.setWatchedItemOnDataLoaded()
      },
      deep: true
    },
    parentNameAndId() {
      this.getPrimaryImagesIfNotNewItem()
    },
    selectedShowLanguageId() {
      this.watchedItem.languageId = this.selectedShowLanguageId
    }
  }
}
</script>
